import React from "react";
import { questionsList } from "../../common/constant/data";
import { useTranslation } from "react-i18next";

const StressForm = ({ formik }) => {
    const { t } = useTranslation()

    const handleCheckBoxPress = (sentence) => {
        const isSelected = formik.values.sentences.includes(sentence);
        if (isSelected) {
            formik.setFieldValue(
                "sentences",
                formik.values.sentences.filter((item) => item !== sentence)
            );
        } else {
            formik.setFieldValue("sentences", [...formik.values.sentences, sentence]);
        }
    };

    return (
        <div className="flex flex-col gap-2  max-h-[55vh] overflow-y-auto mt-5">
            <p className="font-bold md:text-center text-left italic text-white text-[14px]">
                {t(`l2-6-desc1`)}
            </p>
            <p className="font-bold md:text-center text-left  text-white text-[14px]">
                {t(`l2-6-desc2`)}
            </p>
            <p className="font-bold md:text-center text-left  text-white text-[14px]">
                {t(`l2-6-desc3`)}
            </p>

            {questionsList.map((question, index) => (
                <div
                    key={question.value}
                    className="flex  w-full  pb-2 gap-3"
                >
                    <label className="flex items-center space-x-3">
                        <div className="w-4 h-4">
                            <input
                                type="checkbox"
                                checked={formik.values.sentences.includes(question.value)}
                                onChange={() => handleCheckBoxPress(question.value)}
                                className="w-4 h-4 text-green-600 radio-circle border-gray-300 rounded focus:ring-green-500"
                            />
                        </div>

                        <span
                            className={`md:text-[16px] text-sm font-normal text-left ${formik.values.sentences.includes(question.value)
                                ? "text-green-600"
                                : "text-orange-600"
                                }`}
                        >
                            {t(`questionsList.${question.questionKey}`)}
                        </span>
                    </label>

                    {question.value === "Other" &&
                        formik.values.sentences.includes("Other") && (
                            <div className="w-[200px]">
                                <input
                                    type="text"
                                    className={`w-full border-b ${formik.values.sentences.includes("Other")
                                        ? "border-green-600"
                                        : "border-orange-600"
                                        } bg-transparent text-white outline-none focus:border-green-500 py-1`}
                                    placeholder={t('stressPlace')}
                                    value={formik.values.otherSentencesReason}
                                    onChange={(e) =>
                                        formik.setFieldValue(
                                            "otherSentencesReason",
                                            e.target.value
                                        )
                                    }
                                    onBlur={() =>
                                        formik.setFieldTouched("otherSentencesReason", true)
                                    }
                                />
                                {formik.errors.otherSentencesReason &&
                                    formik.touched.otherSentencesReason && (
                                        <p className="text-red-500 text-[10px] mt-1 text-left">
                                            {formik.errors.otherSentencesReason}
                                        </p>
                                    )}
                            </div>
                        )}
                </div>
            ))}

            {formik.errors.sentences && formik.touched.sentences && (
                <p className="text-red-500 text-[10px] mt-1 text-left">{formik.errors.sentences}</p>
            )}
        </div>
    );
};

export default StressForm;
